__turbopack_context__.v({
  "alternateMessage": "contact-module__nUJfTG__alternateMessage",
  "backButton": "contact-module__nUJfTG__backButton",
  "board": "contact-module__nUJfTG__board",
  "boardLink": "contact-module__nUJfTG__boardLink",
  "boardTitle": "contact-module__nUJfTG__boardTitle",
  "contactDetails": "contact-module__nUJfTG__contactDetails",
  "container": "contact-module__nUJfTG__container",
  "containerScrollable": "contact-module__nUJfTG__containerScrollable",
  "content": "contact-module__nUJfTG__content",
  "fadeInItems": "contact-module__nUJfTG__fadeInItems",
  "icon": "contact-module__nUJfTG__icon",
  "left": "contact-module__nUJfTG__left",
  "location": "contact-module__nUJfTG__location",
  "locationActive": "contact-module__nUJfTG__locationActive",
  "locations": "contact-module__nUJfTG__locations",
  "locationsWrapper": "contact-module__nUJfTG__locationsWrapper",
  "right": "contact-module__nUJfTG__right",
  "selectNewPrimaryAgency": "contact-module__nUJfTG__selectNewPrimaryAgency",
  "selectNewPrimaryAgencyIntro": "contact-module__nUJfTG__selectNewPrimaryAgencyIntro",
  "selectNewPrimaryAgencyItem": "contact-module__nUJfTG__selectNewPrimaryAgencyItem",
  "selectTeamMemberClose": "contact-module__nUJfTG__selectTeamMemberClose",
  "selectTeamMemberCloseIcon": "contact-module__nUJfTG__selectTeamMemberCloseIcon",
  "selectedTeamMember": "contact-module__nUJfTG__selectedTeamMember",
  "selectedTeamMemberContent": "contact-module__nUJfTG__selectedTeamMemberContent",
  "selectedTeamMemberImage": "contact-module__nUJfTG__selectedTeamMemberImage",
  "selectedTeamMemberImageWrapper": "contact-module__nUJfTG__selectedTeamMemberImageWrapper",
  "selectedTeamMemberLink": "contact-module__nUJfTG__selectedTeamMemberLink",
  "selectedTeamMemberPosition": "contact-module__nUJfTG__selectedTeamMemberPosition",
  "selectedTeamMemberTitle": "contact-module__nUJfTG__selectedTeamMemberTitle",
  "spacing--lg": "contact-module__nUJfTG__spacing--lg",
  "spacing--md": "contact-module__nUJfTG__spacing--md",
  "spacing--sm": "contact-module__nUJfTG__spacing--sm",
  "spacing--xl": "contact-module__nUJfTG__spacing--xl",
  "spacing--xs": "contact-module__nUJfTG__spacing--xs",
  "spacing--xxl": "contact-module__nUJfTG__spacing--xxl",
  "spacing--xxs": "contact-module__nUJfTG__spacing--xxs",
  "spacing--xxxl": "contact-module__nUJfTG__spacing--xxxl",
  "spacing--xxxs": "contact-module__nUJfTG__spacing--xxxs",
  "team": "contact-module__nUJfTG__team",
  "teamColumn": "contact-module__nUJfTG__teamColumn",
  "teamColumnOffset": "contact-module__nUJfTG__teamColumnOffset",
  "teamMember": "contact-module__nUJfTG__teamMember",
  "teamMemberContent": "contact-module__nUJfTG__teamMemberContent",
  "teamMemberImage": "contact-module__nUJfTG__teamMemberImage",
  "teamMemberImageWrapper": "contact-module__nUJfTG__teamMemberImageWrapper",
  "teamMemberPosition": "contact-module__nUJfTG__teamMemberPosition",
  "teamMemberTitle": "contact-module__nUJfTG__teamMemberTitle",
  "title": "contact-module__nUJfTG__title",
});
